import styled, { ITheme } from '../../../theme'

const State = styled.div<IStateProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0.14px;
  color: ${(props: ITheme & IStateProps) =>
    props.exceeded ? '#f70011' : props.theme.colors.palette.darkGreyTwo};
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    font-size: 12px;
  }
`

export default State

export interface IStateProps {
  exceeded?: boolean
}
